import React, { useState } from "react";
import { ChevronDown, Sparkles } from "lucide-react";

const TYPE_LABELS = { auto: "Voiture", moto: "Moto", poids_lourd: "Poids lourd" };

export const DemoPlatesHint = ({ plates, onPick, selectedType }) => {
  const [open, setOpen] = useState(false);
  if (!plates || plates.length === 0) return null;

  // Priorité au type sélectionné : affiche en premier les plaques du type courant
  const filtered = selectedType
    ? [...plates].sort((a, b) => {
        const aMatch = a.type === selectedType ? 0 : 1;
        const bMatch = b.type === selectedType ? 0 : 1;
        return aMatch - bMatch;
      })
    : plates;

  const matchCount = selectedType
    ? plates.filter((p) => p.type === selectedType).length
    : plates.length;

  return (
    <div
      data-testid="demo-plates-hint"
      className="mt-6 w-full max-w-2xl rounded-xl border border-amber-500/25 bg-amber-500/5 p-4"
    >
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-3 text-left"
        data-testid="demo-plates-toggle"
      >
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-amber-400" />
          <span className="font-mono text-xs uppercase tracking-widest text-amber-300">
            Mode démonstration · {plates.length} plaques
            {selectedType ? ` · ${matchCount} ${TYPE_LABELS[selectedType] || selectedType}` : ""}
          </span>
        </div>
        <ChevronDown
          className={`h-4 w-4 text-amber-400 transition ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <div className="mt-3 grid grid-cols-1 gap-1.5 sm:grid-cols-2">
          {filtered.map((p) => {
            const isMatch = selectedType ? p.type === selectedType : true;
            return (
              <button
                key={p.plaque}
                type="button"
                data-testid={`demo-plate-${p.plaque}`}
                onClick={() => onPick(p.plaque)}
                className={`group flex items-center gap-2 rounded-md px-2.5 py-1.5 text-left transition ${
                  isMatch
                    ? "bg-slate-900/60 hover:bg-slate-800"
                    : "bg-slate-900/20 opacity-60 hover:bg-slate-800/60"
                }`}
              >
                <span className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[11px] font-bold text-slate-950">
                  {p.plaque}
                </span>
                <span className="truncate text-xs text-slate-300 group-hover:text-cyan-300">
                  {p.label}
                </span>
                <span
                  className={`ml-auto rounded-full border px-1.5 text-[9px] uppercase ${
                    isMatch
                      ? "border-cyan-500/40 text-cyan-300"
                      : "border-slate-700 text-slate-500"
                  }`}
                >
                  {TYPE_LABELS[p.type] || p.type}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
